<template>
	<eui-panel
		:vp-inaktiverad="skaVaraInaktiverad"
		:disabled="skaVaraInaktiverad"
		:vp-osynlig="skaVaraOsynlig"
		:class="{
			'-osynlig':skaVaraOsynlig
		}"

		:vp-visa-menyfaltet="vpArIRedigeralage"
		:vp-meny-config.sync="menyConfig"

		style="width: 100%; height: 100%;"

		@menyalternativ-valt-i-panel="onMenyalternativValtIPanel"
	>
		<template #huvudtext>
			<span class="ellipsis">Kundfordringar ({{ vpWidgetData.accountid }}<!-- {{ vpWidgetData.accountname }}-->)</span>
			<!--<span v-if="vpArIRedigeralage" @click="onDeleteWidget" style="float: right; cursor:pointer;">X</span>-->
		</template>

		<!-- Kroppen (default slot): -->
		<div v-html="vpWidgetData.partialHtml"
			style="height:100%;"
		></div>

	</eui-panel>
</template>


<script>
// ################################################################################################################

	import euiPanel from 'v-components/euiPanel';
	import { ssoGeneriskWidgetMixin } from 'v-mixins/ssoGeneriskWidgetMixin';

	export default { 
		name: 'kundreskontraminiwidget',

		// All generisk widgetfunktionalitet, se 'ssoGeneriskWidgetMixin.js'.
		mixins: [ssoGeneriskWidgetMixin],

		// Lokalt registrarade komponenter
		components: {
			[euiPanel.name]: euiPanel,
		},

		//// Utöver de från mixin ovan:
		//props: {
		//},


		//== Lifecycle hooks  ================================================================================================================

	}
</script>

